import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


/**
 *  以下三行代码解决重复点击相同路由时报错的问题
 */

// 获取原形对象上的push函数
const originalPush = Router.prototype.push
// 修改原形对象中的push函数
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
} 

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      children: [
        {
          path: '/index',
          name: '首页',
          component: resolve => require(['../components/page/Index'], resolve)
        },
        {
          path: '/product',
          name: '产品介绍',
          component: resolve => require(['../components/page/Product'], resolve)
        },
        {
          path: '/programme',
          name: '解决方案',
          component: resolve => require(['../components/page/Programme'], resolve)
        },
        {
          path: '/server',
          name: '服务支持',
          component: resolve => require(['../components/page/Server'], resolve)
        },
        {
          path: '/about',
          name: '关于我们',
          component: resolve => require(['../components/page/About'], resolve)
        },
        {
          path: '/newslist',
          name: '新闻列表',
          component: resolve => require(['../components/page/NewsList'], resolve)
        },
        {
          path: '/details',
          name: '新闻详情',
          component: resolve => require(['../components/page/Details'], resolve)
        }
      ]
    },
    {
      path: '*',
      redirect: '/index'
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js